(function() { window.GUID_7dabafd3_4094_4f8c_961c_60b8f5f9e0cb = { getGuid: function() { return "7dabafd3-4094-4f8c-961c-60b8f5f9e0cb"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        class MasterPageSignalR {
            constructor(masterPage) {
                let me = this;
                CS.Views.MasterPageSignalR.Current = me;
                me.masterPage = masterPage;
                me.signalRHelper = CS.SignalRHelper.Instance;
                me.signalRHelper.Start("Messages", function () {
                    me.signalRHelper.Invoke("ListenForMessages", null, CS.CommonData.Current.UserId);
                });
                me.signalRHelper.Receive("MessageReceived", function (response) {
                    if (me.signalRHelper.Logging) {
                        console.info("MessageReceived");
                    }
                    CS.Lag("master-message-received", 150, function () {
                        masterPage.OnNewMessagesReceived();
                    });
                });
                me.signalRHelper.Receive("SendMessageReceived", function (response) {
                    alert('SendMessageReceived');
                    if (me.signalRHelper.Logging) {
                        console.info("SendMessageReceived");
                    }
                    CS.Lag("master-message-received", 150, function () {
                        masterPage.OnNewMessagesReceived();
                    });
                });
            }
            Stop() {
                this.signalRHelper.Stop("Messages", "StopListeningForMessages", CS.CommonData.Current.UserId);
            }
        }
        Views.MasterPageSignalR = MasterPageSignalR;
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));

//# sourceMappingURL=masterpage.signalr.pre.js.map
